import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";
import BriaButtonGroup from "../../../../common/BriaButtonGroup/BriaButtonGroup";
import styles from "./ConsoleAPICard.module.scss";

export type ConsoleAPICardProps = {
	image: string;
	imageType?: "image" | "icon";
	header: string;
	description: string;
	buttons?: ReactNode;
	onClick?: () => void;
};

const ConsoleAPICard = ({ image, imageType = "image", header, description, buttons, onClick }: ConsoleAPICardProps) => {
	return (
		<Box className={`${styles.card} ${onClick ? styles.clickableCard : ""}`} onClick={onClick}>
			<Box className={styles.imageBackground}>
				<img className={`${imageType === "image" ? styles.methodImage : styles.iconImage}`} src={image} />
			</Box>
			<Box className={styles.cardContent}>
				<Box className={styles.cardTexts}>
					<Typography className={styles.cardHeader}>{header}</Typography>
					<Typography className={styles.cardDescription}>{description}</Typography>
				</Box>
				<BriaButtonGroup className={styles.cardButtons} onClick={(e) => e.stopPropagation()}>
					{buttons}
				</BriaButtonGroup>
			</Box>
		</Box>
	);
};

export default ConsoleAPICard;
